import type { NextPage } from 'next';
import Head from 'next/head';

import AccessibilityStatement from '@containers/AccessibiltyStatement';

const AccessibilityStatementPage: NextPage = () => {
  return (
    <>
      <Head>
        <title>Accessibility Statement</title>
      </Head>
      <AccessibilityStatement />
    </>
  );
};

export default AccessibilityStatementPage;
